export function deleteBlackbox(data) {
    let { deleteBlackboxRequest, deleteBlackboxError, deleteBlackboxResult } = this.props

    this.doAction(
        this.WEB_REQUEST_URL + 'blackbox/delete_blackbox',
        this.createBundle('blackbox/delete_blackbox', { blackbox: data }, this.POST, deleteBlackboxRequest, deleteBlackboxResult, deleteBlackboxError)
    )
}
